// extracted by mini-css-extract-plugin
export default {"pageContainer":"Tasks_pageContainer__vI42T","tableContainer":"Tasks_tableContainer__+sYaR"};